export default __webpack_public_path__ + "static/media/item_6.bb36d5fc.webp";